import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const OfferDeclineReasonModal = ({
  open,
  title,
  previewImages = [],
  headerRight = null,
  reason,
  onReasonChange,
  onCancel,
  onSubmit,
  submitLabel = "Submit",
  cancelLabel = "Cancel",
  heading = "Offer Disable Reason",
  descriptionLines = [
    "Could you please provide the reason for the",
    "disable of this offer?",
  ],
  placeholder = "Reason for Disable",
  loading = false,
  overlay = false,
}) => {
  if (!open) return null;

  const content = (
    <div className={overlay ? "w-full max-w-[760px] rounded-[14px] bg-white shadow-[0_20px_60px_rgba(0,0,0,0.24)]" : "p-6"}>
      <div className="w-full flex justify-between items-start mb-4 gap-4">
        <h1 className="font-[600] text-[24px] truncate" title={title}>
          {title || "Offer"}
        </h1>
        {headerRight ? <div className="flex items-center gap-4">{headerRight}</div> : null}
      </div>

      {previewImages?.length > 0 && (
        <div className="mb-6">
          {previewImages.length === 1 ? (
            <div className="w-full h-[200px] rounded-lg overflow-hidden">
              <img
                src={process.env.REACT_APP_S3_URL + previewImages[0]}
                alt="offerPreview"
                className="w-full h-full object-cover"
              />
            </div>
          ) : (
            <Slider className="w-full h-[200px] custom-carousel" dots={true} arrows={false} infinite={true} autoplay={true} speed={800} slidesToShow={1} slidesToScroll={1} autoplaySpeed={4000}>
              {previewImages.map((url, idx) => (
                <img
                  key={idx}
                  src={process.env.REACT_APP_S3_URL + url}
                  alt="offerPreview"
                  className="w-full h-[200px] object-cover"
                />
              ))}
            </Slider>
          )}
        </div>
      )}

      <div className="flex flex-col items-center gap-6">
        <div className="flex flex-col items-center gap-3">
          <h2 className="text-[24px] font-[600] text-[#303030]">
            {heading}
          </h2>
          <div className="text-[16px] font-[400] text-[#8C8C8C] text-center max-w-[600px]">
            {descriptionLines?.map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>
        </div>

        <div className="w-full">
          <textarea
            className="w-full h-[150px] border border-[#E5E7EB] rounded-lg p-4 resize-none focus:outline-none focus:border-[#00ADEF] text-[#303030]"
            placeholder={placeholder}
            value={reason}
            onChange={(e) => onReasonChange?.(e.target.value)}
          />
        </div>
      </div>

      <div className="flex justify-center gap-4 mt-4">
        <button
          className="px-6 py-2 rounded-[5px] text-[14px] font-[600] text-[#00ADEF] border border-[#00ADEF] hover:bg-[#E6F8FF] min-w-[120px]"
          onClick={onCancel}
          disabled={loading}
        >
          {cancelLabel}
        </button>
        <button
          className="px-6 py-2 rounded-[5px] text-[14px] font-[600] text-white bg-[#00ADEF] hover:bg-[#33bdf1] min-w-[120px] disabled:opacity-60"
          onClick={onSubmit}
          disabled={loading || !String(reason || "").trim()}
        >
          {loading ? "Updating..." : submitLabel}
        </button>
      </div>
    </div>
  );

  if (!overlay) {
    return content;
  }

  return (
    <div className="fixed inset-0 z-[10070] flex items-center justify-center bg-black/40 px-4 py-6">
      {content}
    </div>
  );
};

export default OfferDeclineReasonModal;
